import { Quote, Star } from "lucide-react";
import { mediaSrc } from "@/lib/media";
import { PhotoGallery } from "./PhotoGallery";
import { Stars } from "./Stars";

export const TestimonialCard = ({ t, featured = false }) => (
  <div
    data-testid={featured ? `testimonial-featured-${t.id}` : `testimonial-${t.id}`}
    className={`rounded-2xl border bg-background/60 ${featured ? "border-accent/40 bg-accent/5 p-8 md:p-10 shadow-[0_8px_40px_rgba(200,106,81,0.12)]" : "border-border p-6"}`}
  >
    {featured && (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-accent text-white px-3 py-1 text-xs uppercase tracking-widest mb-4">
        <Star size={12} className="fill-white" /> Featured
      </span>
    )}
    {t.kind === "audio" && t.media_url ? (
      <audio controls src={mediaSrc(t.media_url)} className="w-full" data-testid={`testimonial-audio-${t.id}`} />
    ) : t.kind === "video" && t.media_url ? (
      <video controls src={mediaSrc(t.media_url)} className={`w-full rounded-xl ${featured ? "max-h-[26rem]" : "max-h-80"}`} data-testid={`testimonial-video-${t.id}`} />
    ) : t.kind === "image" && (t.media_urls?.length || t.media_url) ? (
      <>
        <PhotoGallery images={t.media_urls?.length ? t.media_urls : [t.media_url]} featured={featured} testid={`testimonial-image-${t.id}`} />
        {t.text && <p className={`mt-3 text-foreground/90 leading-relaxed italic ${featured ? "text-lg md:text-xl font-serif" : "text-sm"}`} data-testid={`testimonial-caption-${t.id}`}>"{t.text}"</p>}
      </>
    ) : (
      <>
        <Quote size={featured ? 30 : 22} className="text-accent/50 mb-2" />
        <p className={`text-foreground/90 leading-relaxed ${featured ? "text-lg md:text-xl font-serif" : ""}`}>{t.text}</p>
      </>
    )}
    <div className="mt-4 flex items-center justify-between gap-3">
      <p className="text-sm font-medium text-accent">— {t.name}</p>
      {t.rating > 0 && <Stars value={t.rating} size={featured ? 18 : 14} />}
    </div>
  </div>
);
